export default "__VITE_ASSET__BhhEjOpE__"